<template>
	<div>
		<CRow>
			<CCol sm="12">
				<CContainer fluid class="container">
					<transition name="fade">
						<CContainer fluid>
							<!-- Select customer -->
							<create-or-find-customer
								:customer-id.sync="customerId"
								:addressId.sync="addressId" />

							<!-- Sender address -->
							<sender-address
								:customerId="customerId"
								:address-id.sync="addressId"
								:addressData.sync="addressData"
								v-if="customerId" />

							<CCard v-if="customerId && addressId">
								<CCardHeader> Validation </CCardHeader>
								<CCardBody>
									<CRow>
										<CCol col="12">
											<GLoadingButton
												@click="submitOrder"
												color="success"
												label="Créer la commande"
												:loading="isLoading"
												class="d-inline-block" />
											<CButton
												color="secondary"
												class="d-inline-block ml-3"
												@click="clear">
												Annuler le panier
											</CButton>
										</CCol>
									</CRow>
								</CCardBody>
							</CCard>
						</CContainer>
					</transition>
				</CContainer>
			</CCol>
		</CRow>
	</div>
</template>

<script>
	import SenderAddress from './_components/sender-address';
	import CreateOrFindCustomer from './_components/create-or-find-customer';
	import GLoadingButton from '../../../../components/ghostlexly-components/GLoadingButton';

	export default {
		components: {
			GLoadingButton,
			CreateOrFindCustomer,
			SenderAddress,
		},
		watch: {
			customerId(newVal) {
				this.$axios
					.get(newVal)
					.then(res => {
						this.customerData = res.data;
					})
					.catch(this.error);
			},
		},

		data() {
			return {
				isLoading: false,
				customerId: null,
				customerData: null,
				addressId: null,
				addressData: null,
			};
		},

		methods: {
			async submitOrder() {
				// (COLIKADO ONLY)
				// --> Verify if the expeditor address is not for France
				if (this.addressData.country !== '/api/countries/RE') {
					this.$toast.error(
						'Vous ne pouvez pas envoyer des COLIKADO depuis un expéditeur en dehors de la Réunion !'
					);
					return false;
				}

				if (!this.addressData.postalCode.startsWith('974')) {
					this.$toast.error("Le code postal saisie n'appartient pas à la Réunion !");
					return false;
				}

				this.isLoading = true;

				// create empty cart
				let cartId = null;
				await this.$axios.post('/api/carts', {}).then(res => {
					cartId = res.data['@id'];
				});

				this.$axios
					.post('/api/orders', {
						cart: cartId,
						contactChannel: 'order.contact_channel.web',
						owner: this.customerId,
						senderAddress: { ...this.addressData, email: this.customerData.email },
					})
					.then(res => {
						this.$router.push(`/orders/${res.data.orderId}/edit`);
					})
					.catch(err => {
						this.isLoading = false;
						this.$toast.error(err.response.data['hydra:description']);
					});
			},

			clear() {
				this.customerId = null;
				this.addressId = null;
			},
		},
	};
</script>

<style>
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.3s;
	}
	.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
		opacity: 0;
	}

	.container {
		min-height: 67vh;
		position: relative;
		display: flex;
	}

	.card-container {
		display: flex;
		flex: 1;
		flex-direction: column;
		justify-content: center;
	}

	.loader {
		position: absolute;
		left: 50%;
		top: 50%;
	}
</style>
